import { useState, useCallback } from 'react';
import { p2201Api, F2110 } from '../../../services/p2201Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for a master record (BR-01/02/03) */
  const resolveAllNames = useCallback(async (data: Partial<F2110>) => {
    const entries: [string, string, string][] = [
      ['employee', 'employee', data.f2110_12 || ''],
      ['vendor', 'vendor', data.f2110_13 || ''],
      ['warehouse', 'warehouse', data.f2110_07 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        p2201Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) [T-F04] */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await p2201Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
